/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DMSTokenResponseDto interface.
 */
export function instanceOfDMSTokenResponseDto(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    return true;
}
export function DMSTokenResponseDtoFromJSON(json) {
    return DMSTokenResponseDtoFromJSONTyped(json, false);
}
export function DMSTokenResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
    };
}
export function DMSTokenResponseDtoToJSON(json) {
    return DMSTokenResponseDtoToJSONTyped(json, false);
}
export function DMSTokenResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
    };
}
